import Devices from "pages/Devices";

export default Devices;
